import { render } from "./announcementOne.vue?vue&type=template&id=57bb530a"
import script from "./announcementOne.vue?vue&type=script&lang=js"
export * from "./announcementOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__